import CrmBadge from './crm-badge'

export { CrmBadge }
